import { useRouter } from 'components/Router'
import lodash from 'lodash'
import React, { useMemo } from 'react'

import Button from '../../../../../1stlog-ui/src/components/Button'
import CopyClipboardTrigger from '../../../../../1stlog-ui/src/components/CopyClipboardTrigger'
import externalValuesToOrderEntryValues from '../../../../../shipmetrics-shared/containers/OrderEntry/utils/externalValuesToOrderEntryValues'
import useTemplates from '../../useTemplates'
import useTemplateValues from '../../useTemplateValues'

const Template = (props) => {
  const { template } = props

  const { remove, load } = useTemplates()

  const router = useRouter()

  const onRemove = async () => {
    await remove(lodash.get(template, 'id'))
    await load()
  }

  const { setTemplateValues } = useTemplateValues()

  const getValues = () => {
    const item = lodash.get(template, 'data', {})

    const values = {
      pickupAddress: {
        name1: item.senderName1,
        name2: item.senderName2,
        name3: item.senderName3,
        street: item.senderStreet,
        streetNumber: item.senderStreetNumber,
        streetNumberAddition: item.senderStreetNumberAddition,
        zip: item.senderZip,
        city: item.senderCity,
        country: item.senderCountry,
        prename: item.senderPrename,
        surname: item.senderSurname,
        phone1: item.senderPhone1,
        mail: item.senderMail,
        EORI: item.senderEORI,
        USTID: item.senderUSTID,
      },
      deliveryAddress: {
        name1: item.receiverName1,
        name2: item.receiverName2,
        name3: item.receiverName3,
        street: item.receiverStreet,
        streetNumber: item.receiverStreetNumber,
        streetNumberAddition: item.receiverStreetNumberAddition,
        zip: item.receiverZip,
        city: item.receiverCity,
        country: item.receiverCountry,
        prename: item.receiverPrename,
        surname: item.receiverSurname,
        phone1: item.receiverPhone1,
        mail: item.receiverMail,
        EORI: item.receiverEORI,
        USTID: item.receiverUSTID,
      },
      invoiceAddress: {
        name1: item.invoiceName1,
        name2: item.invoiceName2,
        name3: item.invoiceName3,
        street: item.invoiceStreet,
        streetNumber: item.invoiceStreetNumber,
        streetNumberAddition: item.invoiceStreetNumberAddition,
        zip: item.invoiceZip,
        city: item.invoiceCity,
        country: item.invoiceCountry,
        prename: item.invoicePrename,
        surname: item.invoiceSurname,
        phone1: item.invoicePhone1,
        mail: item.invoiceMail,
        EORI: item.invoiceEORI,
        USTID: item.invoiceUSTID,
      },
      colis: lodash.map(item.colis, (coli) =>
        lodash.pick(coli, ['height', 'length', 'weight', 'width']),
      ),
      slaType: item.sla_object.name,
    }
    return values
  }

  const onApply = () => {
    const values = getValues()
    // console.log('apply template', { template, values })
    setTemplateValues(externalValuesToOrderEntryValues(values, template?.data))

    // make sure values are saved before redirecting
    setTimeout(() => router.history.push('/'), 0)
  }
  // console.log("template", template)
  const { sla } = lodash.get(template, 'data')

  const link = useMemo(() => {
    const values = getValues()
    return `${window.location.origin}?initial_values=${encodeURIComponent(
      JSON.stringify(values),
    )}`
  }, [])

  return (
    <tr>
      {/* <td style={{ verticalAlign: "middle" }} width="5%">
        {template.id}
      </td> */}
      <td style={{ verticalAlign: 'middle' }}>{template.name}</td>
      <td style={{ verticalAlign: 'middle' }} width="5%">
        {sla}
      </td>
      <td style={{ verticalAlign: 'middle' }} width="1%">
        <div className="d-flex" style={{ whiteSpace: 'nowrap' }}>
          <Button
            icon="fas fa-arrow-circle-right"
            onClick={onApply}
            primary
            className="mr-2"
            sm
          >
            {i18n.t('use_template', 'Vorlage verwenden')}
          </Button>
          {/(localhost|staging)/.test(window.location) && (
            <div className="mr-2">
              <CopyClipboardTrigger content={link} label="Link">
                <div>
                  <Button icon="fas fa-copy" sm>
                    {/* Link kopieren */}
                  </Button>
                </div>
              </CopyClipboardTrigger>
            </div>
          )}
          <Button
            icon="fas fa-trash-alt"
            tooltip="Vorlage löschen"
            onClick={onRemove}
            danger
            sm
          />
        </div>
      </td>
    </tr>
  )
}

export default Template
